import styles from "./styles.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const Loading = (): JSX.Element => (
  <div className={styles.Loading}>
    <p>Loading...</p>
  </div>
);

export default wrapperHOC(Loading, {
  componentName: "Loading-Global",
  showForChina: true,
});
